import BaseActions from '@/store/base/actions'
import MultipleFormActions from '@/store/base/multipleFormData/actions'
import Schema from "@/store/modules/projectWeeks/schema"

const module = 'projectMonths'

export default BaseActions({module}, {

}, [MultipleFormActions(module), Schema])